import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './user/layout/Layout';
import HomePage from './user/pages/HomePage';
import WalletPage from './user/pages/WalletPage';
import StakingPage from './user/pages/StakingPage';
import HistoryPage from './user/pages/HistoryPage';
import P2PPage from './user/pages/P2PPage';
import NoticesPage from './user/pages/NoticesPage';
import NoticeDetailPage from './user/pages/NoticeDetailPage';
import SupportPage from './user/pages/SupportPage';
import ChatPage from './user/pages/ChatPage';
import DayTradingPage from './user/pages/DayTradingPage';
import BlockDealPage from './user/pages/BlockDealPage';
import ETFPage from './user/pages/ETFPage';
import VerificationPage from './user/pages/VerificationPage';
import AccountVerificationPage from './user/pages/AccountVerificationPage';
import IdCardVerificationPage from './user/pages/IdCardVerificationPage';
import PhoneVerificationPage from './user/pages/PhoneVerificationPage';
import SelfieVerificationPage from './user/pages/SelfieVerificationPage';
import AddressVerificationPage from './user/pages/AddressVerificationPage';
import BusinessVerificationPage from './user/pages/BusinessVerificationPage';
import CreditCardVerificationPage from './user/pages/CreditCardVerificationPage';
import MyTransactionRequestsPage from './user/pages/MyTransactionRequestsPage';
import MyInquiriesPage from './user/pages/MyInquiriesPage';
import LoginPage from './user/pages/LoginPage';
import SignUpPage from './user/pages/SignUpPage';
import PendingApprovalPage from './user/pages/PendingApprovalPage';
import AdminRoute from './admin/components/AdminRoute';

import AdminLayout from './admin/layout/AdminLayout';
import AdminDashboard from './admin/pages/AdminDashboard';
import AdminUsersPage from './admin/pages/AdminUsersPage';
import AdminDayTradingPage from './admin/pages/AdminDayTradingPage';
import AdminBlockDealPage from './admin/pages/AdminBlockDealPage';
import AdminETFPage from './admin/pages/AdminETFPage';
import AdminVerificationPage from './admin/pages/AdminVerificationPage';
import AdminTransactionsPage from './admin/pages/AdminTransactionsPage';
import AdminP2PPage from './admin/pages/AdminP2PPage';
import AdminStakingPage from './admin/pages/AdminStakingPage';
import AdminAnnouncementsPage from './admin/pages/AdminAnnouncementsPage';
import AdminSupportPage from './admin/pages/AdminSupportPage';
import AdminSettingsPage from './admin/pages/AdminSettingsPage';
import AdminTransactionRequestsPage from './admin/pages/AdminTransactionRequestsPage';

import { ThemeProvider } from '@/shared/hooks/useTheme';

import ErrorBoundary from './shared/components/ErrorBoundary';

function App() {
    return (
        <ErrorBoundary>
            <ThemeProvider>
                <Router>
                    <Routes>
                        {/* User Routes */}
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/signup" element={<SignUpPage />} />
                        <Route path="/pending-approval" element={<PendingApprovalPage />} />
                        <Route path="/home" element={<Layout><HomePage /></Layout>} />
                        <Route path="/wallet" element={
                            <Layout>
                                <ErrorBoundary>
                                    <WalletPage />
                                </ErrorBoundary>
                            </Layout>
                        } />
                        <Route path="/staking" element={<Layout><StakingPage /></Layout>} />
                        <Route path="/p2p" element={<Layout><P2PPage /></Layout>} />
                        <Route path="/day-trading" element={<Layout><DayTradingPage /></Layout>} />
                        <Route path="/block-deal" element={<Layout><BlockDealPage /></Layout>} />
                        <Route path="/etf" element={<Layout><ETFPage /></Layout>} />
                        <Route path="/notices" element={<Layout><NoticesPage /></Layout>} />
                        <Route path="/notices/:id" element={<Layout><NoticeDetailPage /></Layout>} />
                        <Route path="/notice" element={<Layout><NoticesPage /></Layout>} />
                        <Route path="/support" element={<Layout><SupportPage /></Layout>} />
                        <Route path="/chat" element={<Layout><ChatPage /></Layout>} />
                        <Route path="/my-inquiries" element={<Layout><MyInquiriesPage /></Layout>} />
                        <Route path="/verification" element={<Layout><VerificationPage /></Layout>} />
                        <Route path="/verification/account" element={<Layout><AccountVerificationPage /></Layout>} />
                        <Route path="/verification/id-card" element={<Layout><IdCardVerificationPage /></Layout>} />
                        <Route path="/verification/phone" element={<Layout><PhoneVerificationPage /></Layout>} />
                        <Route path="/verification/selfie" element={<Layout><SelfieVerificationPage /></Layout>} />
                        <Route path="/verification/address" element={<Layout><AddressVerificationPage /></Layout>} />
                        <Route path="/verification/business" element={<Layout><BusinessVerificationPage /></Layout>} />
                        <Route path="/verification/credit-card" element={<Layout><CreditCardVerificationPage /></Layout>} />
                        <Route path="/my-transactions" element={<Layout><MyTransactionRequestsPage /></Layout>} />
                        <Route path="/history" element={<Layout><HistoryPage /></Layout>} />

                        {/* Admin Routes */}
                        <Route path="/kimstar" element={<Navigate to="/kimstar/dashboard" replace />} />
                        <Route path="/kimstar/dashboard" element={<AdminRoute><AdminLayout><AdminDashboard /></AdminLayout></AdminRoute>} />
                        <Route path="/kimstar/users" element={<AdminRoute><AdminLayout><AdminUsersPage /></AdminLayout></AdminRoute>} />
                        <Route path="/kimstar/daytrading" element={<AdminRoute><AdminLayout><AdminDayTradingPage /></AdminLayout></AdminRoute>} />
                        <Route path="/kimstar/blockdeal" element={<AdminRoute><AdminLayout><AdminBlockDealPage /></AdminLayout></AdminRoute>} />
                        <Route path="/kimstar/etf" element={<AdminRoute><AdminLayout><AdminETFPage /></AdminLayout></AdminRoute>} />
                        <Route path="/kimstar/staking" element={<AdminRoute><AdminLayout><AdminStakingPage /></AdminLayout></AdminRoute>} />
                        <Route path="/kimstar/notices" element={<AdminRoute><AdminLayout><AdminAnnouncementsPage /></AdminLayout></AdminRoute>} />
                        <Route path="/kimstar/support" element={<AdminRoute><AdminLayout><AdminSupportPage /></AdminLayout></AdminRoute>} />
                        <Route path="/kimstar/verification" element={<AdminRoute><AdminLayout><AdminVerificationPage /></AdminLayout></AdminRoute>} />
                        <Route path="/kimstar/transactions" element={<AdminRoute><AdminLayout><AdminTransactionsPage /></AdminLayout></AdminRoute>} />
                        <Route path="/kimstar/transaction-requests" element={<AdminRoute><AdminLayout><AdminTransactionRequestsPage /></AdminLayout></AdminRoute>} />
                        <Route path="/kimstar/p2p" element={<AdminRoute><AdminLayout><AdminP2PPage /></AdminLayout></AdminRoute>} />
                        <Route path="/kimstar/settings" element={<AdminRoute><AdminLayout><AdminSettingsPage /></AdminLayout></AdminRoute>} />

                        {/* Redirects */}
                        <Route path="/" element={<Navigate to="/home" replace />} />
                        <Route path="*" element={<div>404 Not Found</div>} />
                    </Routes>
                </Router>
            </ThemeProvider>
        </ErrorBoundary>
    );
}

export default App;
